import {Injectable, TemplateRef} from '@angular/core';
import {Acknowledgments} from "../pd/pd-applications/pd-form/AcknowledgementKeyConstants"
import {BsModalService} from "ngx-bootstrap/modal";
import {BsModalRef} from "ngx-bootstrap/modal/bs-modal-ref.service";

@Injectable()
export class AcknowledgementService {

    private dialogRef: BsModalRef<any> | null = null;
    private messages: { [key: string]: string } = {
        [Acknowledgments.DateOnApplicationAcknowledgement]: "You must click ALL the dates of your PD, not just the first and last date.",
        [Acknowledgments.SubDaysOnApplicationAcknowledgement]: "Substitutes go on grid on day 4 of an absence, retroactive to day 3. This " +
            "means that any consecutive absences beyond 3 days, regardless of the reason, will " +
            "result in the substitute being paid at 1/200th of their grid pay. Therefore, if there are " +
            "any additional sub days before or after your professional development activity, your " +
            "pre-approved claim for reimbursement will be adjusted to reflect the additional " +
            "costs, but should you not have enough funds available, you will be billed. Please " +
            "note that claim payments may be delayed until substitute costs are confirmed. If " +
            "you have any questions, please contact the PD Funds Chair. " +
            "\n\nPlease only choose sub days for school days.",
        [Acknowledgments.SubDaysOnReimbursementAcknowledgement]: "If you have used a sub day, please make sure to fill in the name of your sub " +
            "above and the dates the sub was used.",
        [Acknowledgments.CarAllowanceOnReimbursementAcknowledgement]: "You can only claim mileage if you use your " +
            "vehicle, not both gas and mileage.",
        [Acknowledgments.TransportationOnApplicationAcknowledgement]: "If you are sharing transportation and wish to submit for reimbursement you must have a receipt that shows each individual's name.",
        [Acknowledgments.TransportationOnReimbursementAcknowledgement]: "Ensure you have uploaded your original receipt which must show your name, " +
            "the vendor's name, " +
            "the date, " +
            "the charges, " +
            "the time of travel," +
            " and originating location and destination. " +
            "If your receipt is in currency other than Canadian funds you must include a redacted credit card statement that shows your name, " +
            "the vendor's name, " +
            "the date, " +
            "the original charges, " +
            "the charges in Canadian funds and the exchange rate.",
        [Acknowledgments.AccommodationExpensesOnApplicationAcknowledgement]: "If you are sharing accommodation and wish to submit for reimbursement you must have a receipt that shows each individual's name.",
        [Acknowledgments.AccommodationExpensesOnReimbursementAcknowledgement]: "Ensure you have uploaded your original receipt which must show your name, " +
            "the vendor's name, " +
            "the date and the charges. " +
            "If your receipt is in currency other than Canadian funds you must include a redacted credit card statement that shows your name, " +
            "the vendor's name, " +
            "the date, " +
            "the original charges, " +
            "the charges in Canadian funds and the exchange rate.",
        [Acknowledgments.SubsistenceOnReimbursementAcknowledgement]: "Your claim for subsistence MUST match your " +
            "receipts. You do not need to attach receipts."
    }

    private acknowledgements: { [key: string]: boolean } = {
        [Acknowledgments.DateOnApplicationAcknowledgement]: false,
        [Acknowledgments.SubDaysOnApplicationAcknowledgement]: false,
        [Acknowledgments.SubDaysOnReimbursementAcknowledgement]: false,
        [Acknowledgments.CarAllowanceOnReimbursementAcknowledgement]: false,
        [Acknowledgments.TransportationOnApplicationAcknowledgement]: false,
        [Acknowledgments.TransportationOnReimbursementAcknowledgement]: false,
        [Acknowledgments.AccommodationExpensesOnApplicationAcknowledgement]: false,
        [Acknowledgments.AccommodationExpensesOnReimbursementAcknowledgement]: false,
        [Acknowledgments.SubsistenceOnReimbursementAcknowledgement]: false,
        [Acknowledgments.SubmitOnReimbursementAcknowledgement]: false
    }

    constructor(private modalService: BsModalService,
    ) {


    }

    ShowDialogIfNecessary(key: string, template: TemplateRef<any>): BsModalRef<any> {
        if (!(key in this.acknowledgements)) {
            throw new Error(`Invalid key provided to the acknowledge object, no acknowledgement exists for: ${key}`);
        }
        if (!(key in this.messages)) {
            throw new Error(`Invalid key provided to the messages object, no message exists for: ${key}`);
        }

        if (this.acknowledgements[key]) {
            return null;
        }

        const initialState = {
            initialState: {
                acknowledgementMessage: this.messages[key]
            }
        };
        const config = {
            backdrop: true,
            ignoreBackdropClick: true,

        };

        if (this.dialogRef === null) {
            this.dialogRef = this.modalService.show(
                template, config
            );
        } else {
            return null;
        }


        this.dialogRef.content = {...initialState};
        this.dialogRef?.onHide.subscribe(_ => {
            this.acknowledgements[key] = true;
            this.dialogRef = null;
        })

        return this.dialogRef;
    }
}
